
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useCollectionItemAddOrEdit } from '@/modules/collection/item/model/add.or.edit';

export default defineComponent({
    name: 'CollectionItemAddOrEdit',
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, createOrUpdate } = useCollectionItemAddOrEdit();

        return { v$, model, createOrUpdate };
    }
});
